import Model from "./model";
import Relation from "./relation.model";
import Scope from "./scope.model";
import Survey from "./survey.model";

export default class RelationContact extends Model {
  public name: string = '';
  public email: string = '';
  public phone1: string = '';
  public phone2: string = '';
  public lastname: string = '';
  public lastname_prefix: string = '';
  public initials: string = '';
  public password: string = '';
  // Current password to validate, used for email and password change
  public current_password?: string | null = null;

  public relations: Relation[] = [];
  public scope: Scope = {} as Scope;
  public pivot: {
    rel_contact_id: number,
    rel_id: number
  } = {
    rel_contact_id: 0,
    rel_id: 0
  };
  public surveys: Survey[] = [];
}
